import { BeneficialOwnerReadOnly } from "Components/Users/UserDetailPageContent/Components/RelatedPartyForm/BeneficialOwnerReadOnly";
import { OtherRelationReadOnly } from "Components/Users/UserDetailPageContent/Components/RelatedPartyForm/OtherRelationReadOnly";
import { type PartyDto, RelationType } from "Infrastructure/Api/Api";

type Props = {
  relationType: RelationType;
  partyData: PartyDto;
};

export const RelatedPartyReadOnly = ({ relationType, partyData }: Props) => {
  if (relationType === RelationType.BeneficialOwner) {
    return <BeneficialOwnerReadOnly partyData={partyData} />;
  }

  return <OtherRelationReadOnly partyData={partyData} />;
};
